import styles from './styles.module.css';
import React, {
  useEffect,
  useRef,
  useState,
  useCallback,
  useMemo,
} from 'react';
import { Icons, TerminalsIcon } from '@/assets';
import { ReactSVG } from 'react-svg';
import { useConditionalyOutsideAlerter } from '@/hocs';
import PageContainerAB from '@/components/PageContainerAB/pageContainer';
import FilterPanel from '@/ctComponents/Filter';
import {
  appointmentsByContainer,
  deleteAppointment,
  HistoryAppointment,
  MyAppointments as MyAppointmentsAction,
  MyAppointmentsFilter,
  NewAppointmentsFilter,
  SaveApiResMessage,
} from '@/actions';
import { useHistory, useParams } from 'react-router-dom';
import SearchContainer from './SearchContainer';
import Modal from '@/ctComponents/Modal';
import EditAppointmentModal from './EditAppointmentModal';
import { Icon } from '@/components/Icon';
import AppointmentHistory from '../Inventory/Appointments/bookedCard/AppointmentHistory';
import { formatDateLocale } from '@/ctUtlis/formatDate';
import CustomBadge from '@/components/CustomBadge';
import { createPortal } from 'react-dom';
import PageContainerTabs from '@/components/PageContainerTabs';
import IconButtonV2 from '@/ctComponents/IconButton/IconButtonV2';
import ToCancelAppointments from './ToCancelAppointments';
import YourAppointments from './YourAppointments';
import TooltipIcon from '@/components/Tooltip/TooltipIcon';
import { LinksPopper } from './componenets/LinksPopper';

const MyAppointments = () => {
  const history = useHistory();
  const tabParams = useParams();

  const [display, setDisplay] = useState(false);
  const [show, setShow] = useState(false);
  const [options, setOptions] = useState([]);
  const [sizeOptions, setSizeOptions] = useState([]);
  const [SSLOptions, setSSLOptions] = useState([]);
  const [container, setContainer] = useState('');
  const [containerName, setContainerName] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [historyList, setHistory] = useState([]);
  const [loadingHistory, setLoadingHistory] = useState(false);
  const [orderByToCancel, setOrderByToCancel] = useState(); //"appointment","change",booked
  const [orderByAll, setOrderByAll] = useState(); //"appointment","change",booked
  const [filtersLoaded, setFiltersLoaded] = useState(false);
  const [page, setPage] = useState(1);
  const [expandedRow, setExpandedRow] = useState({
    rowKey: null,
    count: 1,
  });
  const [relatedAppointments, setRelatedAppointments] = useState({});
  const [loadingRelated, setLoadingRelated] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState({
    show: false,
    data: null,
  });
  const [loadingCancel, setLoadingCancel] = useState(false);
  const [appointmentsToCancelCount, setAppointmentsToCancelCount] = useState();
  const [loadingData, setLoadingData] = useState(false);

  const contentRef = useRef();
  const wrapperRef = useRef(null);

  const [tempFilters, setTempFilters] = useState({
    statuses: [],
    terminals: [],
    types: [],
    shippingLines: [],
    originSource: [],
    autobookStatus: [],
  });

  const [filters, setFilters] = useState({
    statuses: [],
    terminals: [],
    types: [],
    shippingLines: [],
    originSource: [],
    autobookStatus: [],
  });
  const [selectedRowForLinks, setSelectedRowForLinks] = useState(null);
  const [popperForLinksPosition, setPopperForLinksPosition] = useState({
    top: 0,
    right: 0,
    height: 0,
    center: 0,
  });

  const [selectedTab, setSelectedTab] = useState(tabParams.tab || 'all');

  useEffect(() => {
    setLoadingData(true);
    MyAppointmentsAction({
      page: 1,
      per_page: 15,
    }).then((res) => {
      setAppointmentsToCancelCount(res.data.cancelableCount);
      setLoadingData(false);
    });
  }, []);

  useEffect(() => {
    if (selectedTab) {
      setExpandedRow({
        rowKey: null,
        count: 1,
      });
      setRelatedAppointments({});
    }
  }, [selectedTab]);

  const filterButtonRef = useRef(null);

  // Load saved filters and orderBy from localStorage on component mount
  useEffect(() => {
    const savedFilters = localStorage.getItem('appointments-filters');
    if (savedFilters) {
      try {
        const parsedFilters = JSON.parse(savedFilters);
        setFilters(parsedFilters);
        setTempFilters(parsedFilters);
      } catch (error) {
        console.error('Error parsing saved filters:', error);
        localStorage.removeItem('appointments-filters');
      }
    }

    // Load saved orderBy for "all" tab from localStorage
    const savedOrderByAll = localStorage.getItem('appointments-orderBy');
    if (savedOrderByAll) {
      try {
        setOrderByAll(savedOrderByAll);
      } catch (error) {
        console.error('Error parsing saved orderBy:', error);
        localStorage.removeItem('appointments-orderBy');
      }
    }

    // Load saved orderBy for "to-cancel" tab from localStorage
    const savedOrderByToCancel = localStorage.getItem(
      'appointments-to-cancel-orderBy'
    );
    if (savedOrderByToCancel) {
      try {
        setOrderByToCancel(savedOrderByToCancel);
      } catch (error) {
        console.error('Error parsing saved orderBy to cancel:', error);
        localStorage.removeItem('appointments-to-cancel-orderBy');
      }
    }

    // Mark filters as loaded regardless of whether they were saved or not
    setFiltersLoaded(true);
  }, []);

  // Save filters to localStorage whenever filters change
  useEffect(() => {
    localStorage.setItem('appointments-filters', JSON.stringify(filters));
  }, [filters]);

  // Save orderByAll to localStorage whenever it changes
  useEffect(() => {
    if (orderByAll) {
      localStorage.setItem('appointments-orderBy', orderByAll);
    }
  }, [orderByAll]);

  // Save orderByToCancel to localStorage whenever it changes
  useEffect(() => {
    if (orderByToCancel) {
      localStorage.setItem('appointments-to-cancel-orderBy', orderByToCancel);
    }
  }, [orderByToCancel]);

  useConditionalyOutsideAlerter(
    wrapperRef,
    () => setDisplay(false),
    (event) => {
      // Don't close if clicking on the filter button
      if (
        filterButtonRef.current &&
        filterButtonRef.current.contains(event.target)
      ) {
        return false;
      }
      return true;
    }
  );

  const resetFilters = () => {
    const emptyFilters = {
      statuses: [],
      terminals: [],
      types: [],
      shippingLines: [],
      originSource: [],
      autobookStatus: [],
    };
    setFilters(emptyFilters);
    setTempFilters(emptyFilters);
    // Clear from localStorage
    localStorage.removeItem('appointments-filters');
    localStorage.removeItem('appointments-orderBy');
    localStorage.removeItem('appointments-to-cancel-orderBy');
    setOrderByAll(undefined);
    setOrderByToCancel(undefined);
    setDisplay(false);
  };

  const getColor = (status) => {
    switch (status) {
      case 'EDITED':
        return { wrapper: '#EBF1FF', color: '#335CFF' };
      case 'CANCELED':
        return { wrapper: '#FFEBEC', color: '#D02533' };
      case 'REJECTED':
        return { wrapper: '#FFEBEC', color: '#D02533' };
      case 'RESERVED':
        return { wrapper: '#E8F8F0', color: '#178C4E' };
      case 'PENDING':
        return { wrapper: '#99A0AE29', color: '#717784' };
      default:
        return { wrapper: '#99A0AE29', color: '#717784' };
    }
  };

  const getFilter = () => {
    MyAppointmentsFilter({
      statuses: '',
      types: '',
      terminals: '',
      shipping_lines: '',
      container_name: '',
    }).then((res) => {
      const transformedArray = [
        {
          category: 'statuses',
          title: 'Status',
          options:
            res.data.statuses?.map((s) => ({
              label: s.title,
              value: s.value,
            })) || [],
        },
        {
          category: 'terminals',
          title: 'Terminal',
          options:
            res.data.terminals?.map((t) => ({
              label: t.slug,
              value: t.id,
            })) || [],
        },
        {
          category: 'types',
          title: 'Type',
          options:
            res.data.types?.map((t) => ({
              label: t.title,
              value: t.value,
            })) || [],
        },
        {
          category: 'shippingLines',
          title: 'SSL',
          options:
            res.data.shippingLines?.map((s) => ({
              label: s.name,
              value: s.id,
            })) || [],
        },
        {
          category: 'originSource',
          title: 'Origin Source',
          options: [
            {
              label: 'Autobook',
              value: 'AUTOBOOK',
            },
            {
              label: 'Manual',
              value: 'MANUAL',
            },
            {
              label: 'External',
              value: 'EXTERNAL',
            },
          ],
        },
        {
          category: 'autobookStatus',
          title: 'Autobook Status',
          options: [
            {
              label: 'On',
              value: 'ON',
            },
            {
              label: 'Off',
              value: 'OFF',
            },
          ],
        },
      ];
      setOptions(transformedArray);
    });
  };

  const AppointmentsOptions = () => {
    NewAppointmentsFilter({
      company: null,
      specifiation: null,
    }).then((res) => {
      setSizeOptions(
        res.data.specifications.map(({ id, size, name, model }) => ({
          value: id,
          label: `${size}${name ? '-' + name : ''}-${model}`,
        }))
      );
      setSSLOptions(
        res.data.companies.map(({ id, name }) => ({
          value: id,
          label: name,
        }))
      );
    });
  };

  const showHistory = useCallback((data) => {
    setSelectedRow(data);
    setLoadingHistory(true);
    HistoryAppointment(data?.containerId || data?.container, data?.terminalId)
      .then((res) => {
        //noScroll();
        setHistory(res.data.appointments);
        setLoadingHistory(false);
      })
      .catch((err) => {
        // notify(err, 'warning');
        setLoadingHistory(false);
      });
  }, []);

  const getOriginSourceClass = (originSource) => {
    switch (originSource) {
      case 'AUTOBOOK':
        return 'text-success-secondary font-bold border border-solid border-success-secondary';
      case 'MANUAL':
        return 'text-primary-blue border font-bold  border-solid border-primary-blue';
      default:
        return 'text-inactive-text font-bold border border-solid border-inactive-text ';
    }
  };

  const getOriginSourceText = (originSource) => {
    switch (originSource) {
      case 'AUTOBOOK':
        return 'Autobook';
      case 'MANUAL':
        return 'Manual';
      case 'EXTERNAL':
        return 'External';
      default:
        return '-';
    }
  };

  const handleResponse = useCallback((data, expandedRowData = null) => {
    return (
      data.data.appointments?.data || data.data.containerAppointments
    )?.map((item) => ({
      id: item?.id,
      appointments_count: item?.appointments_count,
      terminalName: item?.terminal?.slug || '',
      container: item?.container_string || '',
      containerId: item?.container_id || '',
      ssl:
        item?.cabin?.company?.name ||
        item?.inventory?.cabin?.company?.name ||
        '',
      sslId:
        item?.cabin?.company_id || item?.inventory?.cabin?.company_id || '',
      size:
        item?.cabin?.specifications?.size_type ||
        item?.inventory?.cabin?.specifications?.size_type ||
        '',
      sizeId:
        item?.cabin?.specification_id ||
        item?.inventory?.cabin?.specification_id ||
        '',
      cabinId: item?.cabin_id || item?.inventory?.cabin_id || '',
      shift: item?.terminal_appointment_availability?.shift || '',
      returnApt:
        (item?.terminal_appointment_availability?.time_start?.replace(
          /\s?(AM|PM)/gi,
          ''
        ) || '') +
        ' ' +
        (() => {
          const date = item?.terminal_appointment_availability?.date || '';
          if (!date) return '';
          const [year, month, day] = date.split('-');
          return `${month}-${day}-${year.slice(2)}`;
        })(),
      type: item?.type || '',
      license: item?.license_plate || '',
      status: item?.status_text || '',
      statusColor: item?.status || '',
      containerInfo: item.container || '',
      lastUpdate: item?.last_changed_at,
      autobookStatus:
        expandedRowData?.autobookStatus ||
        (item?.autobook_status
          ? 'On'
          : item?.autobook_status === false
          ? 'Off'
          : '-'),
      setAt: expandedRowData?.setAt || item?.set_at,
      bookedAt: item?.created_at,
      appointmentTime: item?.appointment_time || '',
      originSource: item?.origin_source,
      terminalId: item?.terminal_id || '',
      shippingLineTrackingUrl: item?.shipping_line_tracking_url || '',
      cancel_reason: item?.cancel_reason || '',
      terminal: item?.terminal || '',
    }));
  }, []);

  const handleExpandRow = async (rowData, index) => {
    const rowKey = `${rowData.container}-${index}`;
    setExpandedRow({ rowKey, count: rowData.appointments_count - 1 });
    setLoadingRelated(true);
    if (expandedRow.rowKey === rowKey) {
      // Collapse current row
      setExpandedRow({ rowKey: null, count: 1 });
      setRelatedAppointments({});
      setLoadingRelated(false);
    } else {
      // Close any previously expanded row and expand new one

      setRelatedAppointments({});

      try {
        const response = await appointmentsByContainer(
          rowData.container,
          rowData.terminalId
        );
        const relatedData = handleResponse(response, rowData);
        setRelatedAppointments({ [rowKey]: relatedData });
        setLoadingRelated(false);
      } catch (error) {
        console.error('Error fetching related appointments:', error);
      } finally {
        setLoadingRelated(false);
      }
    }
  };

  const handleContainerNameClick = useCallback((e, rowData) => {
    e.preventDefault();

    const containerNumber = rowData.container || '-';
    const trackingUrl = rowData.shippingLineTrackingUrl;

    navigator.clipboard
      .writeText(containerNumber)
      .then((res) => {
        SaveApiResMessage({
          title: res?.data?.messageHeader,
          message: `Container Number "${containerNumber}" Copied`,
          mode: 'success',
        });

        // Open link in new tab after 2 seconds
        setTimeout(() => {
          trackingUrl && window.open(trackingUrl, '_blank');
        }, 1000);
      })
      .catch((err) => {
        SaveApiResMessage({
          title: 'error',
          message: `Container Number "${containerNumber}" Not Copied`,
          mode: 'success',
        });
        setTimeout(() => {
          window.open(trackingUrl, '_blank');
        }, 1000);
      });
  }, []);

  const columns = [
    {
      field: 'id',
      label: '#',
      align: 'center',
      flex: 0.3,
      component: (row, index, isFromExpandedRows = false) => {
        const rowKey = `${row.container}-${index}`;
        const isExpanded = expandedRow.rowKey === rowKey;

        return (
          <div className="relative h-full flex items-center justify-center gap-2">
            {row.cancel_reason && (
              <span
                style={{
                  borderTopRightRadius: 64,
                  borderBottomRightRadius: 72,
                }}
                className="w-1 h-full absolute -left-2 top-0 bg-error rounded-l-40 "
              />
            )}
            {!isFromExpandedRows && (
              <>
                {row.appointments_count > 1 && (
                  <span
                    className="absolute left-0 cursor-pointer w-5 h-5 flex items-center justify-center"
                    onClick={() => handleExpandRow(row, index)}>
                    <Icon
                      src={Icons.arrowUpSmall}
                      width={20}
                      height={20}
                      color={isExpanded ? '#335CFF' : '#525866'}
                      className={`transition-transform duration-200 ${
                        isExpanded ? 'rotate-180' : 'rotate-90'
                      }`}
                    />
                  </span>
                )}
                <span>{index + 1}</span>
              </>
            )}
          </div>
        );
      },
      sortValue: (row, index) => index + 1 || '',
    },

    {
      field: 'terminalName',
      label: 'Terminal',
      align: 'center',
      flex: 4,
      noResetBgColor: true,
      component: (row) => (
        <div
          className={`${styles.logoSection} cursor-pointer relative`}
          onClick={(e) => {
            const rect = e.currentTarget.getBoundingClientRect();

            setPopperForLinksPosition({
              top: rect.top,
              right: rect.right,
              height: rect.height,
              center: rect.height + rect.height / 2,
              width: rect.width,
            });
            setSelectedRowForLinks(row);
          }}>
          <img
            width={80}
            src={TerminalsIcon[row.terminalName]}
            alt={row.terminalName}
          />

          <span>{row.terminalName}</span>
          {selectedRowForLinks?.id === row.id && (
            <LinksPopper
              selectedRowForLinks={selectedRowForLinks}
              popperForLinksPosition={popperForLinksPosition}
              setSelectedRowForLinks={setSelectedRowForLinks}
            />
          )}
        </div>
      ),
      sortValue: (row) => row.terminalName || '',
    },
    {
      field: 'container',
      label: 'Container',
      align: 'center',
      flex: 4,
      noResetBgColor: true,
      component: (row) => (
        <div
          className="cursor-pointer underline"
          onClick={(e) => handleContainerNameClick(e, row)}>
          {row.container}
        </div>
      ),
      sortValue: (row) => row.container || '',
    },
    {
      field: 'ssl',
      label: 'SSL',
      align: 'center',
      flex: 3,
      component: (row) => <div>{row.ssl ? row.ssl : '_'}</div>,
      sortValue: (row) => row.ssl || '',
    },
    {
      field: 'size',
      label: 'Size',
      align: 'center',
      flex: 3,
      component: (row) => <div>{row.size ? row.size : '_'}</div>,
      sortValue: (row) => row.size || '',
    },
    {
      field: 'originSource',
      label: 'Origin Source',
      align: 'center',
      flex: 2,
      component: (row) => (
        <div
          className={`px-3 py-1 w-fit rounded-full min-w-54 mx-auto ${getOriginSourceClass(
            row.originSource
          )}`}>
          {getOriginSourceText(row.originSource)}
        </div>
      ),
      sortValue: (row) => row.originSource || '',
    },
    {
      field: 'autobookStatus',
      label:
        selectedTab === 'all' ? (
          'Autobook Status'
        ) : (
          <>
            <span>
              Autobook <br />
              Status
            </span>
          </>
        ),
      align: 'center',
      flex: 2,
      component: (row) => (
        <div
          className={` ${
            row.autobookStatus === 'On'
              ? 'text-success-secondary font-bold'
              : 'gray-600'
          }`}>
          {row.autobookStatus}
        </div>
      ),
      sortValue: (row) => row.autobookStatus || '',
    },
    ...(selectedTab === 'to-cancel'
      ? []
      : [
          {
            field: 'set_at',
            label: 'Set At',
            align: 'center',
            flex: 2,
            component: (row) => (
              <div>{row.setAt ? formatDateLocale(row.setAt) : '-'}</div>
            ),
            sortValue: (row) => row.setAt || '',
          },
        ]),
    {
      field: 'booked',
      label: 'Booked At',
      align: 'center',
      flex: 2,
      sort: true,
      component: (row) => <div>{formatDateLocale(row.bookedAt)}</div>,
      sortValue: (row) => row.bookedAt || '',
    },
    {
      field: 'appointment',
      label: 'Appointment time',
      align: 'center',
      flex: 2,
      sort: true,
      noResetBgColor: true,
      component: (row) => {
        // Parse the existing returnApt format and reformat it
        const formatAppointmentDisplay = (returnApt) => {
          if (!returnApt) return '';

          // Split by space to separate time and date
          const parts = returnApt.trim().split(' ');
          if (parts.length !== 2) return returnApt;

          const [time, date] = parts;

          // Convert MM-DD-YY to DD-MM-YYYY format
          const [month, day, year] = date.split('-');
          const fullYear = '20' + year; // Convert YY to YYYY
          const formattedDate = `${month}-${day}-${fullYear}`;

          return `${formattedDate} (${time})`;
        };

        return (
          <div
            onClick={() => handlePen(row)}
            className={`border border-solid cursor-pointer hover:bg-black hover:bg-opacity-5 transition-all duration-300 px-2 py-1 rounded-lg ${
              row.originSource === 'AUTOBOOK'
                ? 'border-success-secondary'
                : 'border-border-tertiary '
            }`}>
            {formatAppointmentDisplay(row.returnApt)}
          </div>
        );
      },
      sortValue: (row) => row.returnApt || '',
    },
    {
      field: 'shift',
      label: 'Shift',
      align: 'center',
      flex: 2,
      component: (row) => <div>{row.shift}</div>,
      sortValue: (row) => row.shift || '',
    },
    {
      field: 'change',
      label: 'Last Update',
      align: 'center',
      flex: 2,
      sort: true,
      component: (row) => {
        return <div>{formatDateLocale(row.lastUpdate)}</div>;
      },
      sortValue: (row) => row.lastUpdate || '',
    },

    {
      field: 'type',
      label: 'Type',
      align: 'center',
      flex: 3,
      component: (row) => (
        <div>
          {row.type === 'SINGLE'
            ? 'Single'
            : row.type === 'DUAL'
            ? 'Dual'
            : '-'}
        </div>
      ),
      sortValue: (row) => row.type || '',
    },

    ...(selectedTab === 'to-cancel'
      ? [
          {
            field: 'cancellationReason',
            label: 'Cancellation Reason',
            align: 'center',
            flex: 3,
            textAlign: 'left',
            component: (row, index, isFromExpandedRows = false) =>
              row.cancel_reason ? (
                <div className="text-left flex items-center gap-1 ">
                  <TooltipIcon
                    tooltipId={`cancellation-reason-${row.id} ${
                      isFromExpandedRows ? 'expanded' : ''
                    }`}
                    iconId={`cancellation-reason-${row.id} ${
                      isFromExpandedRows ? 'expanded' : ''
                    }`}
                    content={row.cancel_reason.full}
                  />
                  <span className="line-clamp-1">{row.cancel_reason.slug}</span>
                </div>
              ) : (
                '-'
              ),
            sortValue: (row) => row.license || '',
          },
        ]
      : [
          {
            field: 'license',
            label: 'License',
            align: 'center',
            flex: 3,
            component: (row) => <div>{row.license}</div>,
            sortValue: (row) => row.license || '',
          },
        ]),
    {
      field: 'status',
      label: 'Status',
      align: 'center',
      flex: 4,
      component: (row) => (
        <div
          className={styles.status}
          style={{
            background: getColor(row.statusColor).wrapper,
            color: getColor(row.statusColor).color,
          }}>
          {row.status}
        </div>
      ),
      sortValue: (row) => row.status || '',
    },
    {
      field: 'actions',
      label: 'Actions',
      align: 'center',
      flex: 2,
      noResetBgColor: true,
      component: (row) => {
        const canCancel =
          row.statusColor === 'RESERVED' || row.statusColor === 'EDITED';

        return (
          <div className="flex gap-2">
            <IconButtonV2
              icon="pen"
              onClick={() => handlePen(row)}
              title="Edit appointment"
            />

            <IconButtonV2
              icon="timeBack"
              onClick={() => showHistory(row)}
              title="Show history"
            />

            <IconButtonV2
              icon="xIconBlack"
              disabled={!canCancel}
              onClick={() => setShowCancelModal({ show: true, data: row })}
              title={canCancel ? 'Cancel appointment' : ''}
            />
          </div>
        );
      },
      sortValue: () => '',
    },
  ];

  const handlePen = (row) => {
    if (row?.sizeId && row?.sslId && (row.containerId || row.cabinId)) {
      const queryParams = new URLSearchParams({
        apiData: JSON.stringify({
          size: row.sizeId,
          ssl: row.sslId,
          containerId: row?.containerId ? row.containerId : row?.container,
          isLiveUnload: !row?.containerId,
          cabinId: row?.cabinId,
        }),
        containerData: encodeURIComponent(JSON.stringify(row.containerInfo)),
        cabinId: row?.cabinId,
      }).toString();

      history.push(`/appointment/container?${queryParams}`);
    } else {
      AppointmentsOptions();
      setContainer(row);
      setShow(true);
    }
  };

  const handleCancel = useCallback(() => {
    setLoadingCancel(true);

    deleteAppointment({
      id: showCancelModal.data?.id,
    })
      .then((res) => {
        SaveApiResMessage({
          title: res?.data?.messageHeader || res,
          message: res?.message,
          mode: 'success',
        });
        setShowCancelModal(false);
      })
      .catch((err) => {
        SaveApiResMessage({
          title: 'Error',
          message: err?.message || 'Cancel failed',
          mode: 'warning',
        });
      })
      .finally(() => {
        setLoadingCancel(false);
      });
  }, [showCancelModal.data]);

  const filtersHasValues = useMemo(() => {
    return Object.values(filters).some((value) => value.length > 0);
  }, [filters]);

  return (
    <div className="overflow-x-auto">
      <PageContainerAB
        minWidth={860}
        title="My Appointments"
        mainPage={true}
        page={page}
        setPage={setPage}
        basePath="/my-appointment">
        <>
          <div className="relative mt-4" ref={contentRef}>
            <div className="flex items-center justify-between">
              <div>
                <PageContainerTabs
                  noRerender
                  titlesLinks={[
                    {
                      width: 'fit-content',
                      title: (
                        <div className="flex items-center justify-center whitespace-nowrap">
                          To Cancel
                          {loadingData && !appointmentsToCancelCount ? (
                            <span className="ml-2 text-11 animate-pulse font-bold flex items-center justify-center bg-gray-200 rounded-full w-5 h-5">
                              <span className="h-3 w-2 bg-gray-300 rounded-sm" />
                            </span>
                          ) : (
                            <span className="ml-2 text-11 font-bold flex items-center justify-center bg-primary-blue text-white rounded-full w-5 h-5">
                              {appointmentsToCancelCount || 0}
                            </span>
                          )}
                        </div>
                      ),
                      pushAddress: 'to-cancel',
                    },
                    {
                      title: 'All',
                      pushAddress: 'all',
                      width: 'fit-content',
                    },
                  ]}
                  baseAddress="/my-appointment/"
                  activeTab={selectedTab}
                  setActiveTab={(step) => {
                    setSelectedTab(step);
                  }}
                />
              </div>
              <div className={styles.Top}>
                <SearchContainer
                  setContainerName={setContainerName}
                  setPage={setPage}
                />
                {selectedTab === 'to-cancel' ? null : (
                  <button
                    ref={filterButtonRef}
                    className={
                      !display
                        ? styles.buttonContainer
                        : styles.buttonContainerActive
                    }
                    onClick={() => {
                      getFilter();
                      setDisplay((pre) => !pre);
                      setPage(1);
                    }}>
                    <>
                      <ReactSVG
                        src={Icons.filterNew}
                        className={styles.icon}
                        beforeInjection={(svg) => {
                          svg.querySelectorAll('path').forEach((path) => {
                            path.setAttribute('stroke', '#131517');
                          });
                        }}
                      />

                      <span className={styles.text}>Filter</span>
                    </>
                  </button>
                )}
              </div>
              {display && (
                <div className={styles.FilterPanel} ref={wrapperRef}>
                  <FilterPanel
                    includeLabel={true}
                    lastItemTitle="Autobook Status"
                    options={options}
                    filters={tempFilters}
                    setFilters={setTempFilters}
                    resetFilters={resetFilters}
                    apply={() => {
                      setFilters(tempFilters);
                      setDisplay(false);
                    }}
                    setDisplay={setDisplay}
                  />
                </div>
              )}
            </div>
            <div className="flex items-center text-sm text-gray-600 my-3 gap-1">
              <span className="w-3 h-3  bg-error  flex items-center justify-center rounded-full" />
              Appointments to Cancel
            </div>
            {filtersHasValues && (
              <div className="relative z-99 w-full bg-white rounded-lg items-center flex flex-wrap gap-2 mb-4 ">
                {filters.types.length > 0 &&
                  filters.types.map(({ value, label }) => {
                    return (
                      <CustomBadge
                        key={label}
                        text={`Type: ${label}`}
                        onClick={() => {
                          const newFilters = {
                            ...filters,
                            types: filters.types.filter(
                              (item) => item.value !== value
                            ),
                          };
                          setFilters(newFilters);
                          setTempFilters(newFilters);
                          // Update localStorage
                          localStorage.setItem(
                            'appointments-filters',
                            JSON.stringify(newFilters)
                          );
                        }}
                      />
                    );
                  })}
                {filters.statuses.length > 0 &&
                  filters.statuses.map(({ value, label }) => {
                    return (
                      <CustomBadge
                        key={label}
                        text={`Status: ${label}`}
                        onClick={() => {
                          const newFilters = {
                            ...filters,
                            statuses: filters.statuses.filter(
                              (item) => item.value !== value
                            ),
                          };
                          setFilters(newFilters);
                          setTempFilters(newFilters);
                          // Update localStorage
                          localStorage.setItem(
                            'appointments-filters',
                            JSON.stringify(newFilters)
                          );
                        }}
                      />
                    );
                  })}
                {filters.terminals.length > 0 &&
                  filters.terminals.map(({ value, label }) => {
                    return (
                      <CustomBadge
                        key={label}
                        text={`Terminal: ${label}`}
                        onClick={() => {
                          const newFilters = {
                            ...filters,
                            terminals: filters.terminals.filter(
                              (item) => item.value !== value
                            ),
                          };
                          setFilters(newFilters);
                          setTempFilters(newFilters);
                          // Update localStorage
                          localStorage.setItem(
                            'appointments-filters',
                            JSON.stringify(newFilters)
                          );
                        }}
                      />
                    );
                  })}
                {filters.shippingLines.length > 0 &&
                  filters.shippingLines.map(({ value, label }) => {
                    return (
                      <CustomBadge
                        key={label}
                        text={`SSL: ${label}`}
                        onClick={() => {
                          const newFilters = {
                            ...filters,
                            shippingLines: filters.shippingLines.filter(
                              (item) => item.value !== value
                            ),
                          };
                          setFilters(newFilters);
                          setTempFilters(newFilters);
                          // Update localStorage
                          localStorage.setItem(
                            'appointments-filters',
                            JSON.stringify(newFilters)
                          );
                        }}
                      />
                    );
                  })}
                {filters.originSource.length > 0 &&
                  filters.originSource.map(({ value, label }) => {
                    return (
                      <CustomBadge
                        key={label}
                        text={`Origin Source: ${label}`}
                        onClick={() => {
                          const newFilters = {
                            ...filters,
                            originSource: filters.originSource.filter(
                              (item) => item.value !== value
                            ),
                          };
                          setFilters(newFilters);
                          setTempFilters(newFilters);
                          // Update localStorage
                          localStorage.setItem(
                            'appointments-filters',
                            JSON.stringify(newFilters)
                          );
                        }}
                      />
                    );
                  })}
                {filters.autobookStatus.length > 0 &&
                  filters.autobookStatus.map(({ value, label }) => {
                    return (
                      <CustomBadge
                        key={label}
                        text={`Autobook Status: ${label}`}
                        onClick={() => {
                          const newFilters = {
                            ...filters,
                            autobookStatus: filters.autobookStatus.filter(
                              (item) => item.value !== value
                            ),
                          };
                          setFilters(newFilters);
                          setTempFilters(newFilters);
                          // Update localStorage
                          localStorage.setItem(
                            'appointments-filters',
                            JSON.stringify(newFilters)
                          );
                        }}
                      />
                    );
                  })}
              </div>
            )}

            {selectedTab === 'to-cancel' ? (
              <ToCancelAppointments
                columns={columns}
                containerName={containerName}
                orderBy={orderByToCancel}
                setOrderBy={setOrderByToCancel}
                handleExpandRow={handleExpandRow}
                handleResponse={handleResponse}
                relatedAppointments={relatedAppointments}
                loadingRelated={loadingRelated}
                expandedRow={expandedRow}
                filtersLoaded={filtersLoaded}
                selectedRowForLinks={selectedRowForLinks}
              />
            ) : (
              <YourAppointments
                columns={columns}
                containerName={containerName}
                filters={filters}
                filtersLoaded={filtersLoaded}
                orderBy={orderByAll}
                setOrderBy={setOrderByAll}
                handleExpandRow={handleExpandRow}
                handleResponse={handleResponse}
                relatedAppointments={relatedAppointments}
                loadingRelated={loadingRelated}
                expandedRow={expandedRow}
                selectedRowForLinks={selectedRowForLinks}
              />
            )}

            <Modal
              show={show}
              notClose={true}
              children={
                <EditAppointmentModal
                  containerData={[container.containerInfo]}
                  setShow={setShow}
                  SSLOptions={SSLOptions}
                  SizeOptions={sizeOptions}
                  containerName={container.container}
                />
              }
              icon={'pen'}
              title={'Edit Current Appointment'}
              setShow={setShow}
            />
          </div>
          <AppointmentHistory
            loading={loadingHistory}
            show={!!selectedRow}
            history={historyList}
            container={selectedRow?.container}
            terminalId={selectedRow?.terminalId.toString()}
            onClose={() => {
              setSelectedRow(null);
              setHistory([]);
            }}
          />
          {createPortal(
            <Modal
              show={showCancelModal.show}
              children={
                <span
                  style={{
                    textAlign: 'center',
                    width: '100%',
                    marginTop: '24px',
                  }}>
                  Are you sure you want to cancel your appointment?
                </span>
              }
              submitText={'Yes, Cancel'}
              icon={'cancelCalendar'}
              title={'Cancel'}
              setShow={() => setShowCancelModal({ show: false, data: null })}
              submit={handleCancel}
              loadingbutton={loadingCancel}
            />,
            document.body
          )}
        </>
      </PageContainerAB>
    </div>
  );
};

export default MyAppointments;
